import Record from "../singleton/record";

export default {

    init: Record.init.bind(Record),

    update: Record.update.bind(Record),

    duplicate: Record.duplicate.bind(Record),

    getDefaultValue: Record.getDefaultValue.bind(Record),

    delete: Record.delete.bind(Record),

    isLinkedActive: Record.isLinkedActive.bind(Record),

    getLinkedOptions: Record.getLinkedOptions.bind(Record),

    getSimilarValues: Record.getSimilarValues.bind(Record)

}